'use client'

import { createContext, useContext } from 'react'

export const TenantContext = createContext<string>('')

export const useTenant = () => useContext(TenantContext)
